import styled, { css } from "styled-components";

export const InfoRow = styled.div<{ compact?: boolean; interactive?: boolean; borderColor?: string; backgroundColor?: string }>`
	background-color: #f9f9f9;
	box-sizing: border-box;
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	&:nth-child(odd) {
		background-color: #f1f1f1;
	}
	${(topP) =>
		(topP.compact &&
			css`
				padding: 7px 15px 0px;
			`) ||
		css`
			padding: 14px 20px;
		`}
	${(topP) =>
		(topP.interactive &&
			css`
				&:hover {
					cursor: pointer;
					color: #0079ad;
					transition: all 0.2s;
				}
			`) ||
		css`
			// @ts-ignore
			border-top: solid 3px ${() => topP.borderColor || "rgba(0, 0, 0, 0.1)"};
			background-color: ${() => topP.backgroundColor};
		`}
`;

export const InfoColumn = styled.div<{ width?: string }>`
	flex: 0 0 ${(p) => p.width || "auto"};
	${(p) => (p.width ? "" : "margin-right: 40px;")}
`;

export const InfoColumnValue = styled.div``;

export const InfoColumnLabel = styled.div`
	font-weight: bold;
`;
